
import Vue from "vue";
import _ from "lodash";
import notificationMixin from '../../mixin/notification';
import store from "../../store/shop";
import ShopAPI from '../../common/api/api_shop';
import { TranslateServiceBuilder } from "../../services/Translate/translateServiceBuilder";
import { TableSession } from "@/model/entity/table_session";

const translate = TranslateServiceBuilder.Instance()._;
const api = new ShopAPI();

export default Vue.component('NotificationCategoryOption', {
  components: {
    QTranslate: () => import("../../components/elements/QTranslate.vue"),
  },
  mixins: [
    notificationMixin,
  ],
  data() {
    return {
        isModalCategoryOption: {} as { [tId: string]: boolean },
        isLoading: false,
        errors: "",
    };
  },
  mounted() {
    api.set_token(store.state.token);
    // ヘッダの無料化判断アイコン経由で開けと要求されていれば開く
    this.tryOpenRequested();
  },
  computed: {
    notificationCategoryOptions() {
      return store.state.notificationCategoryOption;
    },
    openCategoryOptionRequested() {
      return store.state.openCategoryOptionRequested;
    },
  },
  watch: {
    // ヘッダから開け要求が来たら開く
    openCategoryOptionRequested() {
      this.tryOpenRequested();
    },
    // 別ページから home へ遷移した直後は通知データが後から入るため、揃ったら開く
    notificationCategoryOptions() {
      this.tryOpenRequested();
    },
  },
  methods: {
    // ヘッダから開け要求があり、保留中の通知が揃っていれば先頭のテーブルのモーダルを開く
    tryOpenRequested() {
      if (!store.state.openCategoryOptionRequested) {
        return;
      }
      const all = store.state.notificationCategoryOption || {};
      const tId = Object.keys(all).find((id) => {
        const notification = (all as any)[id];
        return (
          notification &&
          notification.categoryOptions &&
          notification.categoryOptions.length > 0
        );
      });
      // 通知データがまだ来ていない場合はフラグを残し、揃ったときに再試行する
      if (!tId) {
        return;
      }
      this.$set(this.isModalCategoryOption, tId, true);
      store.commit("clearOpenCategoryOptionRequest");
    },
    showNotification(tId, notificationCategoryOption) {
      let statusText = 'を確認してください。';
      let seatName = '';
      let receiptNo = '';

      if (store.state.shopSetting.has_guide) {
        _.forEach(store.state.tableGroups, function (tableGroup) {
          _.forEach(tableGroup.table_seats, function (table_seat) {
            if (table_seat.table_sessions.length && table_seat.table_sessions[0].id == tId) {
              seatName = table_seat.name;
            }
          });
        });

        return seatName + '「' + notificationCategoryOption.categoryOptions.map(option => option.formatted_name).join(', ') + '」' + statusText;
      } else {
        let tableSession = _.find(store.state.tableSessions, (tableSession) => tableSession.id == tId) as TableSession|null;

        if (tableSession) {
          receiptNo = tableSession.no.toString();
        }

        return 'No.' + receiptNo + '「' + notificationCategoryOption.categoryOptions.map(option => option.formatted_name).join(', ') + '」' + statusText;
      }
    },
    allValueCheckbox(notificationCategoryOption) {
        return notificationCategoryOption.matchedOrders.every(menu => menu.is_checked);
    },
    allChangeCheckbox(notificationCategoryOption, event) {
        notificationCategoryOption.matchedOrders.forEach(menu => {
            menu.is_checked = event.target.checked;
        });
    },
    handleClick(tId) {
        this.$set(this.isModalCategoryOption, tId, true);
    },
    handleClickStart(notificationCategoryOption, tId) {
      this.startCategoryOption(notificationCategoryOption, tId);
    },

    startCategoryOption(notificationCategoryOption, tId) {
      let message = "";
      const matchedOrdersData = notificationCategoryOption.matchedOrders.map(order => ({
        is_checked: order.is_checked,
        order_id: order.order_id,
        option_price: order.option_price
      }));
      api
        .start_category_option({
            matched_orders: matchedOrdersData,
            category_options: notificationCategoryOption.categoryOptions,
        })
        .then((response) => {
            if (response.data.status !== "success") {
                message =
                response.data.message ||
                translate("hall-0046", "保存に失敗しました。");
                this.showErrorNotification(message);
                this.errors = message;
                return;
            }
            store.commit('removeNotificationCategoryOption', tId);
            this.$set(this.isModalCategoryOption, tId, false);
            store.dispatch("fetchTableSessions");
            this.isLoading = false;
        })
        .catch((err) => {
            message =
                err.response.data.message ||
                translate("hall-0046", "保存に失敗しました。");
            this.showErrorNotification(message);
            this.errors = message;
            this.isLoading = false;
        });
    },
  },
  filters: {
    priceFilter(price: number): string {
      const formatter = new Intl.NumberFormat("ja-JP");

      return formatter.format(price);
    },
  },
});
